import type { BCCheckoutType } from '@/types/BigCommerce/BCCheckout'
import type { StandardOrder } from '@/types/ShopFront/CheckoutStandards'
import { getCartFromResponse } from '../FramedCheckout/cartServices'
import { standardizeOrder } from './standardizeOrder'

export type BCResponseStandardizer = (input: {
  bigcResponse: BCCheckoutType,
  order: StandardOrder
}) => Promise<StandardOrder>
export const standardizeOrderFromResponse: BCResponseStandardizer = async ({
  bigcResponse, order,
}) => {
  const cart = getCartFromResponse(bigcResponse?.cart, order)
  const newOrder = await standardizeOrder({
    ...bigcResponse,
    customerId: order.cart.customerId,
  }, cart)
  return newOrder
}

export default standardizeOrderFromResponse
